<template>
  <div id="app">
    <Headerbar></Headerbar>
    <router-view/>
    <Footerbar></Footerbar>
  </div>
</template>

<script>

import Headerbar from "@/components/public/headerbar"
import Footerbar from "@/components/public/footerbar"
export default {
   components:{
    Headerbar,
    Footerbar
  }
}
</script>

<style>
body,html{
  overflow-x:hidden;
}
</style>



// WEBPACK FOOTER //
// src/App.vue